(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
(() => {
  function init(scope) {
    const root=scope.querySelector('.bac-product');
    if(!root || root.dataset.bacReady) return;
    root.dataset.bacReady='true';
    const section=root.closest('.shopify-section');
    const installments=root.querySelector('.bac-installments');
    if(installments) {
      const placeInstallments=()=>{
        const payment=root.querySelector('.shopify-payment-button');
        const more=payment && payment.querySelector('more-payment-options-link > .shopify-payment-button__more-options');
        if(more && more.previousElementSibling!==installments) more.before(installments);
        else if(!more && payment && payment.nextElementSibling!==installments) payment.after(installments);
      };
      placeInstallments();
      const paymentObserver=new MutationObserver(placeInstallments);
      paymentObserver.observe(root,{childList:true,subtree:true});
      section.addEventListener('shopify:section:unload',()=>paymentObserver.disconnect(),{once:true});
    }
    const dialog=section.querySelector('.bac-lightbox');
    const zoom=root.querySelector('[data-bac-zoom]');
    if(zoom && dialog) {
      zoom.addEventListener('click',()=>{
        const active=root.querySelector('[data-product-single-media-wrapper]:not(.hide)');
        const image=active && active.querySelector('img');
        if(!image) return;
        const wrapper=active.querySelector('[data-zoom]');
        const target=dialog.querySelector('img');
        target.src=wrapper ? wrapper.dataset.zoom : image.currentSrc || image.src;
        target.alt=image.alt;
        target.classList.remove('bac-expanded');
        dialog.showModal();
      });
      dialog.querySelector('[data-bac-close]').addEventListener('click',()=>dialog.close());
      dialog.querySelector('img').addEventListener('click',event=>event.currentTarget.classList.toggle('bac-expanded'));
      dialog.addEventListener('click',event=>{if(event.target===dialog) dialog.close();});
      dialog.addEventListener('close',()=>zoom.focus());
    }
    const primary=root.querySelector('[data-add-to-cart]');
    const sticky=section.querySelector('[data-bac-buy]');
    if(primary && sticky) {
      const sync=()=>{
        sticky.disabled=primary.disabled || primary.getAttribute('aria-disabled')==='true' || primary.classList.contains('btn--loading');
        sticky.textContent=primary.querySelector('[data-add-to-cart-text]').textContent.trim();
        const price=root.querySelector('.price:not(.price--on-sale) .price-item--regular, .price--on-sale .price-item--sale');
        if(price) section.querySelector('[data-bac-price]').textContent=price.textContent.trim();
      };
      sync();
      const observer=new MutationObserver(sync);
      observer.observe(root.querySelector('.product-single__meta'),{subtree:true,childList:true,attributes:true,characterData:true});
      sticky.addEventListener('click',()=>{if(!sticky.disabled) primary.click();});
      section.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
